module.exports = __webpack_public_path__ + "static/media/chevron-single.e8bf6e87.svg";